import React from "react";
import { Link } from "react-router-dom";
import backimg from "../../../assets/solutions-images/hero_banner.webp";
import "../solution.css";

const ItService = () => {
    return (
        <>
            {/* Hero Section */}
            <div>
                <div
                    className="bg-cover bg-center bg-no-repeat min-h-[400px] md:min-h-[502px] flex flex-col gap-6 md:gap-8 justify-center px-4 py-12 md:px-8 lg:px-16 hover_herosec"
                    style={{ backgroundImage: `url(${backimg})` }}
                >
                    <h1
                        style={{ wordSpacing: "8px" }}
                        data-aos="fade-down"
                        className="text-2xl md:text-3xl lg:text-5xl font-semibold text-white w-full sm:w-full md:w-2/3 lg:w-[680px]"
                    >
                        Accelerate Service Responses and Operations
                    </h1>
                    <p className="text-white text-sm md:text-base w-full md:w-2/3 lg:w-2/5" data-aos="fade-down">
                        Tekpossible is your partner for maximizing ServiceNow ITSM capabilities. We help you automate service delivery and set up analytics-driven workflows. Leveraging our expertise, we create role-based workspaces, break down information silos, and foster teamwork.
                    </p>
                    <Link
                        data-aos="zoom-in"
                        data-aos-delay="300"
                        to="/contact-us"
                        className="w-fit bg-[#C32A7C] px-5 py-2 sm:px-6 sm:py-2.5 lg:px-7 lg:py-2 rounded-lg text-white hover:bg-white hover:text-[#C32A7C] transition-colors duration-400 ease-in-out text-sm sm:text-sm md:text-sm lg:text-lg text-center whitespace-nowrap"
                    >
                        Contact Us
                    </Link>
                </div>
            </div>

            {/* What We Offer Section */}
            <div className="bg-[#FFFFFF] mt-6 mb-10">
                <div className="flex flex-col sm:justify-center text-center items-center gap-4 py-8 px-4" data-aos="fade-up"
                    data-aos-delay="300">
                    <h1 className="text-[#1A5298] font-bold text-xl md:text-3xl">
                        What can we help you achieve with ITSM solutions by ServiceNow?
                    </h1>
                </div>

                <div className="bg-white mt-5 mb-10">
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8 px-4 md:px-10 lg:px-10 py-5 items-start">
                        {[
                            {
                                title: "Streamline Your Operations",
                                description:
                                    "Reduce time and resources spent on reactive tasks by implementing cost-effective, analytics-driven workflows that won’t strain your budget.",
                            },
                            {
                                title: "Improve Decision-Making",
                                description:
                                    "Enhance business decisions, streamline service delivery, and continuously improve services through role-based workspaces.",
                            },
                            {
                                title: "Delight Your Employees",
                                description:
                                    "Enhance query handling, elevate employee experiences, and achieve heightened visibility with autonomous issue resolution.",
                            },
                        ].map((item, index) => (
                            <div
                                key={index}
                                className="flex flex-col items-center text-center justify-center lined_hoverset" data-aos="zoom-in-up"
                                data-aos-delay="200"
                            >
                                <h2 className="text-[#000] text-base lg:text-[15px] xl:text-xl font-semibold w-[233px] text-center">
                                    {item.title}
                                </h2>
                                <div className="mt-2 flex flex-col items-center md:w-40">
                                    <img
                                        className="object-contain my-5"
                                        src={require("../../../assets/solutions-images/line_gapers.svg").default}
                                        alt="Enhance IT Workflows"
                                    />
                                </div>
                                <p className="text-sm md:text-base max-w-[352px]">{item.description}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {/* ITSM Solutions Section */}
            <div className="flex flex-col justify-center items-center px-4 py-8 md:py-12 lg:py-12 bg-[#F0FAFF]">
                <div className="relative max-w-screen-xl">
                    <h2 className="text-black font-semibold text-2xl md:text-3xl lg:text-3xl text-center lg:mb-5">
                        ITSM Solutions
                    </h2>
                    <h5 className="text-xl mb-8 lg:mb-12 text-black font-medium text-center">
                        Tekpossible – your trusted ally in unlocking the full potential of ServiceNow ITSM.
                    </h5>
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-x-20 px-4" data-aos="zoom-in-down">
                        {[
                            {
                                img: require("../../../assets/solutions-images/icon_top1.svg").default,
                                head: "Change Management",
                                desc: "Utilize built-in AI, data-driven workflows, and customized change models to streamline, automate, and accelerate the pace of change, ensuring quicker time-to-value delivery.",
                            },
                            {
                                img: require("../../../assets/solutions-images/icon_top2.svg").default,
                                head: "Problem Management",
                                desc: "Quickly restore services, prevent future issues, and minimize disruptions by using structured workflows designed to diagnose root causes and implement solutions effectively.",
                            },
                            {
                                img: require("../../../assets/solutions-images/icon_top3.svg").default,
                                head: "Request Management",
                                desc: "Enable a modern, omnichannel approach to empower employees to collaborate, self-solve, and request services 24/7, ensuring seamless interaction with IT and other shared services groups.",
                            },
                            {
                                img: require("../../../assets/solutions-images/icon_top4.svg").default,
                                head: "Incident Management",
                                desc: "Utilize machine learning to automate incident assignment and collaborate with stakeholders through the Major Incident Management portal to quickly restore services.",
                            },
                        ].map((service, index) => (
                            <div
                                key={index}
                                className="sec3 flex flex-col items-center text-center transform transition-all duration-300 hover:scale-105 hover:shadow-xl mx-auto w-full max-w-[600px] mt-10"
                            >
                                <div className="w-full bg-gradient-to-r from-[#981A59] to-[#124B6A] h-[10px]"></div>
                                <div className="flex flex-col px-6 py-8 items-center rounded border bg-[#FFFFFF] w-full transition-all duration-300">
                                    <img
                                        className="-mt-[75px] md:-mt-[75px] lg:-mt-15 transform transition-transform duration-300"
                                        src={service.img}
                                        alt="Service"
                                    />
                                    <h4 className="sec3title text-xl font-medium text-black mt-6">
                                        {service.head}
                                    </h4>
                                    <p className="text-sm text-black mt-2 lg:mt-6 lg:w-[447px] md:w-[550px] w-[250px] px-2 md:px-4 lg:px-6 min-h-[60px] flex items-center justify-center">
                                        {service.desc}
                                    </p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>


            <div className="bg-[#F4F4F4] w-full py-10 md:py-12">
                <div className="flex flex-col items-center text-center px-4 md:px-6">
                    <h1 className="text-[#1A5298] font-bold text-xl md:text-2xl lg:text-4xl text-center mb-5 w-full" data-aos="fade-down">
                        Our ServiceNow ITSM Expertise
                    </h1>
                    <h5 className="text-md text-black font-medium text-center" data-aos="fade-up">
                        Change Management | Request Management | Problem Management | Incident Management
                    </h5>
                </div>
            </div>

            {/* Call to Action Section */}
            <div className="bg-[#FFFFFF] w-full py-10 md:py-12">
                <div className="flex flex-col items-center text-center px-4 md:px-6"data-aos="fade-down-right">
                    <h1 className="line_heightsests text-[#1A5298] font-bold text-xl md:text-2xl lg:text-4xl text-center mb-8 w-full md:w-2/3 lg:w-2/4">
                        Ready to supercharge your ServiceNow ITSM capabilities?
                    </h1>
                    <Link
                        data-aos="zoom-in"
                        data-aos-delay="300"
                        to={"/contact-us"}
                        className="w-[140px] px-6 py-2 md:px-4 md:py-2.5 bg-[#C32A7C] rounded-lg text-white font-semibold hover:bg-[#F6F6F6] hover:text-[#C32A7C] transition-colors duration-300 text-sm md:text-base text-center whitespace-nowrap mt-4 border border-[#C32A7C]"
                    >
                        Contact Us
                    </Link>
                </div>
            </div>
        </>
    );
};

export default ItService;